// KSA phone helpers — shared with ContactUsForm

export const normalizeMsisdn = raw => {
  if (!raw) return null;
  let s = String(raw).trim().replace(/\s+/g, '');
  if (s.startsWith('+')) s = s.slice(1);
  if (s.startsWith('00966')) s = s.replace(/^00966/, '966');
  if (s.startsWith('966')) return s;
  if (s.startsWith('05')) return '966' + s.slice(1);
  if (s.startsWith('5')) return '966' + s;
  return s;
};

export const isValidKsaMsisdnInput = rawValue => {
  if (!rawValue) return false;
  const norm = normalizeMsisdn(String(rawValue));
  if (!norm) return false;
  return /^9665\d{8}$/.test(norm) || /^96605\d{8}$/.test(norm);
};
